export default "__VITE_ASSET__CeKS0ua0__"